<template>
  <div class="w-full">
    <div style="margin-bottom: 16px">
      <DirectionsHeaderTable
        @search-term="onSearchTerm"
        :search="search"
      />
    </div>
    <div   v-if='!loading'>
    <div
  
      class="w-full overflow-x-auto rounded-xl border border-gray-300 bg-white directions"
    >
      <a-table
        :columns="columns"
        rowKey="id"
        :data-source="data"
        :pagination="false"
      >
      
        <span
          slot="actions"
          slot-scope="text, record"
          class="text-sm font-medium text-right whitespace-nowrap flex"
        >
          <a-switch
            v-model="record.is_active"
            @change="onSwitchChange($event, record)"
          />
          <router-link
            :to="`./edit/?id=${record.id}`"
            class="
              ml-3
              h-6
              w-6
              p-1
              text-blue-600
              dark:text-blue-500
              shadow
              rounded
            "
            append
          >
            <img class="h-full w-full" src="@/assets/icons/pen.svg" alt="" />
          </router-link>
        </span>
      </a-table>
    </div>
    <div class="mt-4 flex justify-end">
      <a-pagination
        v-model="page"
        :page-size="pageSize"
        :page-size-options="pageSizeOptions"
        :total="count"
        show-size-changer
        size="large"
        @showSizeChange="onShowSizeChange"
      />
    </div></div>
      <div v-if="loading" class="absolute w-full justify-center top-1/3 left-0 ">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 64px" spin />
      </a-spin>
    </div>
  </div>
</template>
<script>
import DirectionsHeaderTable from "@/components/Dashboard/Directions/DirectionsHeaderTable";
import ModalConfirmation from "@/components/Dashboard/Roles/ModalConfirmation.vue";
import capitalize from "@/utils/checkForms.js";
const columns = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    width: "30%",
    sorter: (a,b)=>{if(a.name < b.name) {return -1} if(a.name > b.name) {return 1}return 0},
  },
  {
    title: "Descripción",
    dataIndex: "description",
    key: "description",
    width: "60%",
    scopedSlots: { customRender: "description" },
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    width: "10%",
    scopedSlots: { customRender: "actions" },
  },
];

export default {
  components: {
    ModalConfirmation,
    DirectionsHeaderTable,
  },
  data() {
    return {
      data: [],
      columns,
      loading: false,
      current: null,
      showModal: false,
      page: 1,
      searchTerm: null,
      pageSize: 20,
      count: 0,
      search: null,
      pageSizeOptions: ['20', '40', '60', '80', '100']
    };
  },
  created() {
    if (this.$route.query.search) {
      this.searchTerm = this.$route.query.search;
      this.search = this.searchTerm;
    }
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page);
    } else {
      this.page = 1;
    }
        if (this.$route.query.pageSize) {
      this.pageSize = parseInt(this.$route.query.pageSize);
    } else {
      this.pageSize = 20;
    } 
    this.query = `?page=${this.page}&page_size=${this.pageSize}&`;
    this.start();
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  watch: {
    'page': function (newVal, oldVal) {
      if (newVal == this.$route.query.page) {
        return;
      } else {
        this.$router.replace({ query: { page: this.page } });
      }
    },
    pageSize: function (newVal, oldVal) {
      if (newVal == this.$route.query.pageSize) {
      return;
      } else {
        this.$router.replace({ query: { page: this.page, pageSize:this.pageSize } });
      }
    },
    "$route.query.page": function () {
      this.start();
    },
  },
  methods: {
    onSearchTerm(value) {
      this.showToast("info", "Buscando resultados...");
      this.searchTerm = value?.trim();
      this.search = this.searchTerm;
      this.$router.replace({
        query: { page: this.page, search: this.searchTerm },
      });
      if (1 == this.$route.query.page || !this.$route.query.page) {
        this.start();
      }
      this.page = 1;
    },
    async start() {
      let query = `?page=${this.page}&page_size=${this.pageSize}`;
      if (this.searchTerm) query += `&search=${this.searchTerm}`;
      this.loading = true;
      let { error, data } = await this.$api.readDirections(query);
      this.loading = false;

      if (error) {
        this.data = [];
        this.showToast("error", "Error listando direcciones.");
      }
      if (data) {
        this.data = data.results.map(direction=>{
          return {
            ...direction,
            name:capitalize(direction.name),
            description: direction.description ? direction.description[0]?.toUpperCase() + direction.description.substring(1).toLowerCase(): 'Sin descripción'
          }
        });
        this.count = data.count;
      }
    },
    async onSwitchChange(checked, record) {
      this.showToast("info", "Procesando cambio de estado...");
      this.loading = true;
      let { error, data } = await this.$api.changeStateDirection(
        { state: checked },
        record.id
      ); // to change state
      this.loading = false;
      if (error)
        this.showToast("error", "Error cambiando estado de la dirección.");

      if (data) {
        this.showToast("success", "Cambio de estado éxitoso.");
        this.start();
      }
    },
    onShowSizeChange(page, page_size){
    this.page = page
    this.pageSize = page_size
    this.start();
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },
};
</script>
<style >
.directions .ant-table-thead > tr > th {
  font-weight: bold;
  color:#6b7280;
}

</style>
